import { gql } from '@grandvisionhq/graphql';

const variantProductPriceItem = gql`
  fragment VariantProductPriceItemFragment on ProductPriceItem {
    priceType
    originalPrice {
      amount
    }
  }
`;

export { variantProductPriceItem };
//# sourceMappingURL=variant-product-price-item.js.map
